import { Text } from "@nju/ui";

interface IRowProps {
  title: string;
  value: string;
}

export function Row({ title, value }: IRowProps) {
  return (
    <div className="flex justify-between">
      <Text
        size={{
          "@onlyMobile": "m",
          "@fromTablet": "l",
        }}
      >
        {title}
      </Text>
      <Text
        className="whitespace-nowrap"
        size={{
          "@onlyMobile": "m",
          "@fromTablet": "l",
        }}
        weight="bold"
      >
        {value}
      </Text>
    </div>
  );
}
